import React from "react";
import { connect } from "react-redux";
import clsx from "clsx";

import { uiActions } from "../../store";

import styles from "./notification.module.scss";

import NotificationSuccess from "../../static/images/notification-success.png";
import NotificationError from "../../static/images/notification-error.png";

const getIcon = variant => {
	switch (variant) {
		case "info":
			return NotificationSuccess;
		case "success":
			return NotificationSuccess;
		case "failure":
			return NotificationError;
		default:
			throw new Error("Undexpected variant");
	}
};

const Notification = ({ show, variant, title, hideNotification }) => {
	return (
		<div
			className={clsx(
				styles.notification,
				show && styles.show,
				styles[variant],
			)}
		>
			<h1 className={styles.heading}>
				<img
					className={styles.icon}
					src={getIcon(variant)}
					width="22"
					alt=""
				/>
				<span>{title}</span>
			</h1>
			<button onClick={hideNotification} className={styles.close}>
				&#10006;
			</button>
		</div>
	);
};

const mapStateToProps = state => ({
	show: state.ui.notification.show,
	variant: state.ui.notification.variant,
	title: state.ui.notification.title,
});

const mapDispatchToProps = {
	hideNotification: uiActions.hideNotification,
};
const notification = connect(mapStateToProps, mapDispatchToProps)(Notification);
export { notification as Notification };
